module.exports = __webpack_public_path__ + "img/mato_grosso.03a2f99b.jpg";